module.exports = __webpack_public_path__ + "centric-card-bottom-left.2xW1dDRO.png";